var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExpense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FFE2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40002259_102473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 3.14C10.9473 3.0476 10.4807 3.00093 10 3C6.1339 3 3 6.1339 3 10C3 13.8661 6.1339 17 10 17C13.8661 17 17 13.8661 17 10C16.9991 9.51933 16.9524 9.05267 16.86 8.6",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99961 7.90001C9.22611 7.90001 8.59961 8.37041 8.59961 8.95001C8.59961 9.52961 9.22611 10 9.99961 10C10.7731 10 11.3996 10.4704 11.3996 11.05C11.3996 11.6296 10.7731 12.1 9.99961 12.1M9.99961 7.90001C10.6086 7.90001 11.128 8.19191 11.3198 8.60001M9.99961 7.90001V7.20001M9.99961 12.1C9.39061 12.1 8.87121 11.8081 8.67941 11.4M9.99961 12.1V12.8",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.50144L16.4232 3.57684M17 6.13604L16.9174 3.97304C16.9174 3.46274 16.6129 3.14494 16.0578 3.10504L13.871 3.00214",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40002259_102473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpense);
export default __webpack_public_path__ + "static/media/icon-expense.3ef80d3186b049c91763dfe6290c4bed.svg";
export { ForwardRef as ReactComponent };